var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"home-title"},[_vm._v(" Bienvenue sur votre espace professionnels de santé - Rare à l'écoute ")]),_c('div',{staticClass:"home-content"},[_c('button',{staticClass:"home-button",on:{"click":_vm.login}},[_vm._v(" Je me connecte ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }